import { render, staticRenderFns } from "./12-ColorSpaces.vue?vue&type=template&id=75d79191&scoped=true"
import script from "./12-ColorSpaces.vue?vue&type=script&lang=ts"
export * from "./12-ColorSpaces.vue?vue&type=script&lang=ts"
import style0 from "./12-ColorSpaces.vue?vue&type=style&index=0&id=75d79191&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d79191",
  null
  
)

export default component.exports